import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse, unwrapApiResponse } from '@/api/patterns/crud';
import type { PlatformAdmin, AddPlatformAdminArgs, RevokePlatformAdminArgs } from '../types';

export const platformAdminsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPlatformAdmins: builder.query<PlatformAdmin[], void>({
      query: () => '/platform/admins',
      transformResponse: unwrapListResponse<PlatformAdmin>,
      providesTags: [{ type: 'PlatformAdmins', id: 'LIST' }],
    }),

    addPlatformAdmin: builder.mutation<PlatformAdmin, AddPlatformAdminArgs>({
      query: (args) => ({
        url: '/platform/admins',
        method: 'POST',
        body: args,
      }),
      transformResponse: unwrapApiResponse<PlatformAdmin>,
      invalidatesTags: [{ type: 'PlatformAdmins', id: 'LIST' }],
    }),

    revokePlatformAdmin: builder.mutation<void, RevokePlatformAdminArgs>({
      query: ({ userId, reason }) => ({
        url: `/platform/admins/${userId}`,
        method: 'DELETE',
        body: reason ? { reason } : undefined,
      }),
      invalidatesTags: [{ type: 'PlatformAdmins', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetPlatformAdminsQuery,
  useAddPlatformAdminMutation,
  useRevokePlatformAdminMutation,
} = platformAdminsApi;
